module.exports = __webpack_public_path__ + "img/pix.025b4412.svg";